import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Presentational table for the Free Grants page (065). Data-fetching and state stay in the
 * FreeGrantsPage container.
 *
 * Every label rendered here — length, end date, "Was: …", billing — is computed by the server
 * (`freeAccessGrantAdminService.present`). The client does not derive them, so the page, the CSV
 * export and the API can never disagree about what a grant says.
 */

const STATUS_CLASS = {
  active: 'fg-pill fg-pill--active',
  expired: 'fg-pill fg-pill--expired',
  revoked: 'fg-pill fg-pill--revoked',
};

const BILLING_CLASS = {
  success: 'fg-pill fg-pill--success',
  partial: 'fg-pill fg-pill--waiting',
  failed: 'fg-pill fg-pill--failed',
  user_action_required: 'fg-pill fg-pill--waiting',
  not_required: 'fg-pill fg-pill--none',
  pending: 'fg-pill fg-pill--none',
};

export default function FreeGrantsTable({ grants = [], onRevoke, onRetry, busyId }) {
  return (
    <div className="uv-table-scroll fullwidth-table track-table-body staff-listing-admin-table-body">
      <table className="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th>User</th>
            <th>Granted</th>
            <th>Length</th>
            <th>Ends</th>
            <th>Billing</th>
            <th>Reason</th>
            <th>By</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {grants.map((g) => (
            <tr key={g.id}>
              <td data-label="User">
                {g.user_id ? (
                  <Link to={`/user-detail/${btoa(String(g.user_id))}`} title="Open user profile">
                    {g.user_name || `User ${g.user_id}`}
                  </Link>
                ) : (
                  <span>{g.user_name || '—'}</span>
                )}
                <span className="mock-sub" style={{ display: 'block', fontSize: 11, color: '#8a9c9a' }}>
                  {g.was_label}
                </span>
              </td>
              <td data-label="Granted">{(g.created_at || '').slice(0, 10) || '—'}</td>
              <td data-label="Length">{g.length_label}</td>
              <td data-label="Ends">{g.ends_label}</td>
              <td data-label="Billing">
                <span
                  className={BILLING_CLASS[g.billing_status] || 'fg-pill fg-pill--none'}
                  title={g.billing_message || ''}
                >
                  {g.billing_label}
                </span>
              </td>
              <td data-label="Reason" style={{ maxWidth: 220 }}>{g.reason}</td>
              <td data-label="By">{g.admin_email || '—'}</td>
              <td data-label="Status">
                <span className={STATUS_CLASS[g.status] || 'fg-pill fg-pill--none'}>{g.status}</span>
              </td>
              <td data-label="">
                {/* Retry is offered only where it can do something: a store call that failed. */}
                {g.billing_status === 'failed' && (
                  <button
                    type="button"
                    className="fg-btn"
                    disabled={busyId === g.id}
                    onClick={() => onRetry(g)}
                  >
                    Retry
                  </button>
                )}
                {g.status === 'active' && (
                  <button
                    type="button"
                    className="fg-btn fg-btn--danger"
                    disabled={busyId === g.id}
                    onClick={() => onRevoke(g)}
                    style={{ marginLeft: 6 }}
                  >
                    Revoke
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
